// extracted by css-extract-rspack-plugin
export default {"cls1":"TabbedPreviewList-cls1_HgJ","cls2":"TabbedPreviewList-cls2_fE2 TabbedPreviewList-cls1_HgJ"};